import { Link, useLocation, useNavigate } from "react-router-dom";

const Breadcrumb = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const pathnames = location.pathname
        .split("/")
        .filter((x) => x);

    return (
        <>
            {
                pathnames.length > 0 ? (
                    <button className="breadcrumb-btn apply-btn" onClick={() => navigate("/")}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#FFF" width={20} height={20} viewBox="0 0 640 640"><path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z" /></svg> Home
                    </button>
                ) : (null)
            }
        </>
    );
};

export default Breadcrumb;
